import { createSelector } from 'reselect';

import getPickupTimeWithFallback from './getPickupTimeWithFallback';
import { IPickupSaleBodyContentHttpDto } from './getPickupSaleBodyContent';

export default createSelector([getPickupTimeWithFallback], (pickupTime): IPickupSaleBodyContentHttpDto => ({
  PickupTime: pickupTime,
}));
